import script from "./placementFee.vue?vue&type=script&setup=true&lang=js"
export * from "./placementFee.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__